var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    fill: "#FFDCA8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.111 12.57a6.658 6.658 0 0 1-3.11-5.636H3.484c-.16.002-.318.026-.471.07l12.844 12.792 7.253-7.227Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.666 13.6a6.658 6.658 0 0 1-1.778-.258l-7.742 7.716a1.778 1.778 0 0 1-2.507 0L1.777 8.267c-.04.145-.06.294-.062.444V26.49a1.778 1.778 0 0 0 1.778 1.778h24.889a1.778 1.778 0 0 0 1.777-1.778V12.613c-1.05.648-2.26.99-3.493.987ZM4.71 26.489H3.475v-1.271l6.462-6.41 1.253 1.254-6.48 6.427Zm23.654 0h-1.245l-6.48-6.427 1.254-1.253 6.462 6.409.009 1.27ZM26 11.2A3.6 3.6 0 1 0 26 4a3.6 3.6 0 0 0 0 7.2Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIco);
export default __webpack_public_path__ + "static/media/email_ico.d8d777ed9a93ab8755431358b0d1bba3.svg";
export { ForwardRef as ReactComponent };